import { render, staticRenderFns } from "./NearMatchResolveCard.vue?vue&type=template&id=47bb0bd8&scoped=true&lang=html&"
import script from "./NearMatchResolveCard.vue?vue&type=script&lang=js&"
export * from "./NearMatchResolveCard.vue?vue&type=script&lang=js&"
import style0 from "./NearMatchResolveCard.vue?vue&type=style&index=0&id=47bb0bd8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb0bd8",
  null
  
)

export default component.exports